import types from './types';

const loadAuthSuccess = (user) => ({
  type: types.AUTH_SUCCESS,
  payload: {
    user
  }
});

const loadAuthFail = (data) => ({
  type: types.AUTH_FAIL,
  payload: {
    data
  }
});

const setIsCertifier = (isCertifier) => ({
  type: types.SET_IS_CERTIFIER,
  payload: {
    isCertifier
  }
});

const setNoRoles = (noRoles) => ({
  type: types.SET_NO_ROLES,
  payload: {
    noRoles
  }
});

const setIsReadOnly = (isReadOnly) => ({
  type: types.SET_IS_READONLY,
  payload: {
    isReadOnly
  }
});

const setIsAdmin = (isAdmin) => ({
  type: types.SET_IS_ADMIN,
  payload: {
    isAdmin
  }
});

const setUserSession = (userSession) => ({
  type: types.SET_USER_SESSION,
  payload: {
    userSession
  }
});

const setUserLayers = (userLayers) => ({
  type: types.SET_USER_LAYERS,
  payload: {
    userLayers
  }
});

const setUpdatePrompt = (shouldPrompt) => ({
  type: types.SET_UPDATE_PROMPT,
  payload: {
    shouldPrompt
  }
});

const logout = (data) => ({
  type: types.LOGOUT
});

const loadPerimeterToken = (token) => ({
  type: types.TOKEN_PERIMETER,
  payload: {
    token
  }
});

const loadPointOfOriginToken = (token) => ({
  type: types.TOKEN_POO,
  payload: {
    token
  }
});

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  loadAuthSuccess: loadAuthSuccess,
  loadAuthFail: loadAuthFail,
  setIsCertifier: setIsCertifier,
  setIsReadOnly: setIsReadOnly,
  setNoRoles: setNoRoles,
  setIsAdmin: setIsAdmin,
  logout: logout,
  loadPerimeterToken: loadPerimeterToken,
  loadPointOfOriginToken: loadPointOfOriginToken,
  setUserSession: setUserSession,
  setUserLayers: setUserLayers,
  setUpdatePrompt: setUpdatePrompt
};
